module.exports = __webpack_public_path__ + "static/img/statusCorrectStaticTom.dad6ca14.png";